import React from "react";
import "../scss/Footer.scss";
// @ts-ignore
import Logo from "../Assets/Images/seekhologo.webp";
// @ts-ignore
import fb from "../Assets/Images/fb.webp";
// @ts-ignore
import Youtube from "../Assets/Images/youtube-icon.webp";
// @ts-ignore
import insta from "../Assets/Images/instaIcon.webp";
import { Link } from "react-router-dom";

const Footer: React.FC = () => {
  return (
    <>
      <div className="container-fluid footer-container">
        <div className="container sub-container">
          <div className="logo-div">
            <img src={Logo} width="200px" height="60px" alt="Logo" />
          </div>
          <div className="terms-container">
            {/* <span>
              <Link to="faqs" target="_top">
                FAQs
              </Link>
            </span> */}
            <span>
              <Link to="/privacypolicy" target="_top">
                Privacy Policy
              </Link>
            </span>
            <span>
              <Link to="/terms" target="_top">
                Terms & Conditions
              </Link>
            </span>
          </div>
          <div className="line-div-mobile"></div>
          <div className="icons-container">
            <span>
              <a
                href="https://www.facebook.com/profile.php?id=61589560892805"
                target="_blank"
                rel="noreferrer"
              >
                <img src={fb} width="28px" height="28px" alt="Facebook" />
              </a>
            </span>
            <span>
              <a
                href="https://www.instagram.com/sekho.digital/"
                target="_blank"
                rel="noreferrer"
              >
                <img src={insta} width="28px" height="28px" alt="Instagram" />
              </a>
            </span>
            {/* <span>
              <a
                href="https://play.google.com/store/apps/details?id=com.jazzeducator"
                target="_blank"
                rel="noreferrer"
              >
                <img src={Youtube} width="28px" height="28px" alt="Youtube" />
              </a>
            </span> */}
          </div>
        </div>
        <div className="line-div"></div>
        <div className="footer-heading-div">
          <div className="c-icon">c</div>
          <div className="heading">
            Copyright 2026, All Rights Reserved by Sekho
          </div>
        </div>
      </div>
    </>
  );
};
export default Footer;
